import Blockly from 'blockly/browser'
import { defineBlock } from '../Util'

defineBlock(
  'sirenia_api_windows_all',
  {
    message0: 'all desktop windows',
    args0: [],
    tooltip: 'Gets all windows on the desktop',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#all-windows',
    output: null
  },
  function(block) {
    return [`Windows.all()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_windows_for_app',
  {
    message0: 'all app windows',
    args0: [],
    tooltip: 'Gets all windows shown by attached application',
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#windows-for-current-application',
    output: null
  },
  function(block) {
    return [`Windows.forApp()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_windows_primary',
  {
    message0: 'primary window',
    args0: [],
    tooltip: "Gets attached application's primary window",
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#primary-window',
    output: null
  },
  function(block) {
    return [`Windows.primary`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)
